import Modal from 'bootstrap/js/dist/modal';
import Cookies from 'js-cookie';

const COOKIE_NAME = 'pepite_global_modal';
const COOKIE_DAYS = 5;
const DELAY_MS = 3000;

const modalElement = document.querySelector('#global-modal') as HTMLElement | null;

if (modalElement && !Cookies.get(COOKIE_NAME)) {
  window.setTimeout(() => {
    const modal = Modal.getOrCreateInstance(modalElement);
    modalElement.addEventListener(
      'hidden.bs.modal',
      () => {
        Cookies.set(COOKIE_NAME, '1', {
          expires: COOKIE_DAYS,
          sameSite: 'Lax',
          path: '/',
        });
      },
      { once: true },
    );
    modal.show();
  }, DELAY_MS);
}
